import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

const FeePaymentForm = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = new useNavigate();
  const feeMonth = queryParams.get("month");
  const feeType = queryParams.get("type");
  const examName = queryParams.get("exam");
  const otherFeeName = queryParams.get("fee_name");

  const [student, setStudent] = useState({});
  const [feesDetails, setFeesDetails] = useState([
    {
      paymentType: feeType,
      mode: "",
      amount: "",
      month: feeMonth || "",
      paidBy: "",
      date: new Date().toISOString().split("T")[0], // Default to today's date
      examName: examName || "",
      otherFeeName: otherFeeName || "",
      remark: "", // Added remark field
    },
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setStudent(response.data); // Set the form data with the fetched student details
        } else {
          toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching student data.");
      }
    };

    fetchStudentData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFeesDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[0] = {
        ...updatedDetails[0],
        [name]: name === "mode" ? value : value.toUpperCase(),
      };
      return updatedDetails;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form from refreshing the page
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/fees/payment/${id}`,
        { fees_details: feesDetails },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success("Fee Paid successfully.");
        if (otherFeeName == "Admission Fee") {
          const token = JSON.parse(localStorage.getItem("token"));
          const addmissionFeeMarkResponse = await axios.put(
            `${process.env.REACT_APP_API_URL}/api/students/${id}/mark-paid`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }
        if (otherFeeName === "Admission Fee") {
          setTimeout(() => {
            navigate(`/erp/admissions/list`);
          }, 2000);
        } else {
          setTimeout(() => {
            navigate(`/erp/fees/payment/details/${id}`);
          }, 2000);
        }
      } else {
        toast.error("Failed to add/update fees details.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting fees details.");
    }
  };

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            {otherFeeName === "Admission Fee" ? (
              <Link
                to={`/erp/admissions/list`}
                className="btn btn-secondary mb-3 pe-4"
              >
                &#8592; Back
              </Link>
            ) : (
              <Link
                to={`/erp/fees/payment/details/${id}`}
                className="btn btn-secondary mb-3 pe-4"
              >
                &#8592; Back
              </Link>
            )}

            <h3 className="text-center text-success">Enter Payment Details</h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>Student ID - {id}</h5>
          </div>
        </div>

        <div className="mb-5">
          <h2 className="text-center text-primary mb-4">Student Details</h2>
          <table className="table table-bordered table-hover table-sm">
            <tbody>
              <tr>
                <td className="fw-bold" style={{ width: "60%" }}>
                  Name
                </td>
                <td>{student.student_name}</td>
              </tr>
              <tr>
                <td className="fw-bold">Roll Number</td>
                <td>{student.class_roll_number}</td>
              </tr>
              <tr>
                <td className="fw-bold">Class</td>
                <td>{student.student_class}</td>
              </tr>
              <tr>
                <td className="fw-bold">Admission Number</td>
                <td>{student.admission_number}</td>
              </tr>
              <tr>
                <td className="fw-bold">Father&apos;s Name</td>
                <td>{student.father_name}</td>
              </tr>
              <tr>
                <td className="fw-bold">Father&apos;s Contact Number</td>
                <td>{student.contact_number_father}</td>
              </tr>
              <tr>
                <td className="fw-bold">Payment Type</td>
                <td>
                  {feeType === "tuition_fee"
                    ? "Tuition Fee"
                    : feeType === "transportation_fee"
                    ? "Transportation Fee"
                    : feeType === "exam_fee"
                    ? "Examination Fee"
                    : "Other Fee"}
                </td>
              </tr>
              {feeType === "tuition_fee" || feeType === "transportation_fee" ? (
                <tr>
                  <td className="fw-bold">Fees Month</td>
                  <td>{feeMonth}</td>
                </tr>
              ) : feeType === "exam_fee" ? (
                <tr>
                  <td className="fw-bold">Exam Name</td>
                  <td>{examName}</td>
                </tr>
              ) : (
                <tr>
                  <td className="fw-bold">Fee Name</td>
                  <td>{otherFeeName}</td>
                </tr>
              )}
              <tr>
                <td className="fw-bold">Payment Date</td>
                <td>{feesDetails[0].date}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4">
              <label htmlFor="paymentMode" className="form-label">
                Payment Mode
              </label>
              <select
                className="form-control"
                id="paymentMode"
                name="mode"
                value={feesDetails[0].mode}
                onChange={handleChange}
                required
              >
                <option value="">Select...</option>
                <option value="Cash">CASH</option>
                <option value="UPI">UPI</option>
                <option value="IMPS/RTGS/NEFT">IMPS/RTGS/NEFT</option>
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="amount" className="form-label">
                Amount
              </label>
              <input
                type="number"
                className="form-control"
                id="amount"
                name="amount"
                value={feesDetails[0].amount}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label htmlFor="paidBy" className="form-label">
                Paid By
              </label>
              <input
                type="text"
                className="form-control"
                id="paidBy"
                name="paidBy"
                value={feesDetails[0].paidBy}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="remarks" className="form-label">
                Remarks
              </label>
              <textarea
                className="form-control"
                id="remarks"
                name="remark"
                value={feesDetails[0].remark}
                onChange={handleChange}
                rows="1"
              ></textarea>
            </div>
          </div>

          <div className="d-grid gap-2 d-flex justify-content-center mt-4">
            <button type="submit" className="btn btn-success">
              Submit Fee
            </button>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default FeePaymentForm;
